import React, { useEffect } from "react";
import { faq } from "./COPPHA";
import HeaderImage from "../../components/HeaderImage";
import { Link } from "react-router-dom";

const OpenPublishingCoursePage: React.FC = () => {

      useEffect(() => {
        const element = document.getElementById("coppha");
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, []);

  return (
    <>
      <HeaderImage image="/assets/images/backgrounds/coppha.jpg"   alt="COPPHA Header"
  showButton={true}
  buttonText="Explore"
  buttonLink="https://wacren.net/en/establishing-a-diamond-oa-publishing-ecosystem-for-public-health-research-in-africa-the-coalition-for-open-access-publishing-of-public-health-in-africa-coppha/" />
    <div className="max-w-6xl mx-auto p-4" id="coppha">
      {/* Course Title Section */}
      <section className="mb-16">
      <h2 className="text-lg font-bold text-green-800 mb-6">COPPHA OPEN PUBLISHING COURSE (2025)</h2>
        <p className="text-sm mb-6">
          A six-week MOOC held from January 13 to February 23, 2025, this course introduced researchers to open access publishing and peer review practices through structured weekly facilitation.
        </p>

        <div className="max-w-6xl mx-auto">
          <h4 className="text-xl font-semibold text-green-800 mb-4">Course Structure</h4>
          <div className="space-y-4">
            <div className="bg-green-700 text-white p-4 rounded-lg text-sm font-semibold shadow-md">
              Open Access Publishing
            </div>
            <div className="bg-green-700 text-white p-4 rounded-lg text-sm font-semibold shadow-md">
              Open Reviewing and a Case Study
            </div>
            <div className="bg-green-700 text-white p-4 rounded-lg text-sm font-semibold shadow-md">
              Publish-Review-Curate (PRC) Model
            </div>
            <div className="bg-green-700 text-white p-4 rounded-lg text-sm font-semibold shadow-md">
              Posting a Preprint, Performing Open Reviews, Course Reflection
            </div>
          </div>

          <p className="text-sm mt-6 text-center">
            All COPPHA course resources are openly licensed and available through the COPPHA Community on BAOBAB.
          </p>

          <div className="mt-6 text-center">
            <Link to="https://baobab.wacren.net/communities/coppha/records" target="_blank" className="bg-blue-400 text-white px-6 py-2 rounded-md font-semibold" >Enrol Now</Link>
          </div>
        </div>
      </section>

      {/* COPPHA PublishNow Section */}
      <section className="mb-16">
        <h3 className="text-xl text-green-800 font-bold mb-4">COPPHA PUBLISHNOW</h3>
        <p className="text-sm mb-4">
          COPPHA PublishNow is an open peer review platform operated by WACREN that implements the PRC (Publish, Review, Curate) model. It allows researchers to engage in open review of preprints and receive constructive feedback, with ORCID integration and optional anonymity.
        </p>
        <h4 className="text-lg text-green-900 font-bold mb-2">THE PUBLISH–REVIEW–CURATE (PRC) MODEL</h4>
        <ul className="list-disc list-inside text-sm mb-6">
          <li>Rapid dissemination of research</li>
          <li>Transparent and open evaluation</li>
          <li>Focus on scientific quality over journal prestige</li>
          <li>Researcher-led publication control</li>
        </ul>
        <p className="text-sm text-gray-700">
          The PRC model decentralizes the gatekeeping role of journals and amplifies African-led research.
        </p>
      </section>

      {/* PRC Model Workflow */}
<section className="mb-16 bg-blue-700 py-12 px-6 rounded-lg">
  <h3 className="text-2xl font-bold text-center text-white mb-10">
    HOW THE PRC MODEL WORKS
  </h3>
  <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12">
    {/* PUBLISH */}
    <div className="flex flex-col items-center text-center">
      <div className="w-32 h-32 bg-yellow-400 rounded-full flex items-center justify-center text-white font-bold text-md shadow-lg">
        PUBLISH
      </div>
      <p className="text-sm text-white mt-4 max-w-xs">
        Upload manuscripts as preprints to BAOBAB.
      </p>
    </div>

    {/* Arrow */}
<div className="hidden md:block">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-10 h-10 text-white"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 5l7 7-7 7"
    />
  </svg>
</div>


      <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 text-white md:hidden" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
    </svg>

    {/* REVIEW */}
    <div className="flex flex-col items-center text-center">
      <div className="w-32 h-32 bg-orange-500 rounded-full flex items-center justify-center text-white font-bold text-md shadow-lg">
        REVIEW
      </div>
      <p className="text-sm text-white mt-4 max-w-xs">
        Get openly reviewed on COPPHA PublishNow with transparent reports.
      </p>
    </div>

    {/* Arrow */}
<div className="hidden md:block">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-10 h-10 text-white"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 5l7 7-7 7"
    />
  </svg>
</div>


          <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 text-white md:hidden" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
    </svg>

    {/* CURATE */}
    <div className="flex flex-col items-center text-center">
      <div className="w-32 h-32 bg-green-700 rounded-full flex items-center justify-center text-white font-bold text-md shadow-lg">
        CURATE
      </div>
      <p className="text-sm text-white mt-4 max-w-xs">
        Organize reviewed preprints into thematic collections.
      </p>
    </div>
  </div>

</section>



      {/* Pathways to Journal Publication */}
<section className="mb-16">
  <h3 className="text-xl font-bold text-green-900 mb-4">Pathways to Journal Publication</h3>
  <p className="text-sm mb-6">
    Authors can submit reviewed preprints to journals or use overlay journals that formalize open peer review workflows. Visit COPPHA PublishNow to participate.
  </p>

  {/* Top Grid: Training Resources & Publications */}
  <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-10">
    <div>
      <h4 className="uppercase text-md font-bold text-green-900 tracking-wide mb-3">Training Resources</h4>
      <ul className="list-disc list-inside text-sm space-y-2">
        <li>Peer Review Process and Predatory Publishers</li>
        <li>Role of AI in Peer Review</li>
        <li>How to Conduct Effective Peer Reviews</li>
        <li>Performing a Peer Review Assignment</li>
        <li>Posting a Preprint to BAOBAB Repository</li>
      </ul>
    </div>

    <div>
      <h4 className="uppercase text-md font-bold text-green-900 tracking-wide mb-3">Publications</h4>
      <ul className="list-disc list-inside text-sm space-y-2">
        <li>Open publishing of public health research in Africa</li>
        <li>Open access publication of public health research in African journals</li>
        <li>Final Report – Peoples-uni Capacity Building Experiment</li>
      </ul>
    </div>
  </div>

  {/* Full Width: News and Get Involved Section */}
  <div className="bg-gray-50 p-6 rounded-lg flex flex-col md:flex-row md:items-start md:gap-6">
    <div className="flex-1 mb-6 md:mb-0">
      <h4 className="uppercase text-md font-bold text-green-900 tracking-wide mb-3">News and Blog Posts</h4>
      <ul className="list-disc list-inside text-sm space-y-2">
        <li>Call for Expressions of Interest: Reconfiguring PublicHealth.Africa</li>
        <li>Completion of the 2025 COPPHA Open Publishing Course</li>
        <li>COPPHA Peer Review Course Achieves Significant Milestones</li>
        <li>COPPHA Peer Review Course 2024 Now Open for Enrollment</li>
      </ul>
    </div>
    <div className="flex-1">
      <button className="bg-green-700 text-white px-6 py-2 rounded-md font-semibold mb-4 md:mb-2">
        Get Involved
      </button>
      <p className="text-sm text-gray-700">
        Join our community to mentor, co-develop courses, or collaborate on impactful public health knowledge sharing. Contact us at:
        <br />
        <a href="mailto:eoi@publichealth.africa" className="underline text-blue-800">
          eoi@publichealth.africa
        </a>
      </p>
    </div>
  </div>
</section>



      {/* Testimonial Section */}
      <section className="mb-16">
        <blockquote className="bg-gray-100 p-6 rounded-lg text-center text-sm italic">
          “I love this training as it’s an eye-opener for me... A BIG thank you to all the supporters and organizers of this course for the immense impact and valuable insights added to my research journey.”
          <br />
          <span className="font-semibold">— OA, Lecturer, Nigeria</span>
        </blockquote>
      </section>

      {/* Stats Section */}
      <section className="mb-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 border-t border-b py-6 text-center">
          <div>
            <h4 className="text-xl font-bold text-green-700">181</h4>
            <p className="text-sm text-gray-700">Enrolled</p>
          </div>
          <div>
            <h4 className="text-xl font-bold text-green-700">91</h4>
            <p className="text-sm text-gray-700">Active Participants</p>
          </div>
          <div>
            <h4 className="text-xl font-bold text-green-700">41</h4>
            <p className="text-sm text-gray-700">Certificates Earned</p>
          </div>
          <div>
            <h4 className="text-3xl font-bold text-green-700">24</h4>
            <p className="text-sm text-gray-700">Countries Represented</p>
          </div>
        </div>
      </section>

      {/* FAQ Placeholder */}
        <section className="mb-16">
          <h3 className="text-2xl font-semibold text-center mb-6">Frequently Asked Questions</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {faq.map(({question, answer}, index) => (
              <div key={index} className="bg-gray-100 p-6 rounded-lg text-sm">
                <p className="font-semibold text-foreground">{question}</p>
                <p>{answer}</p>
               </div>
            ))}
          </div>
        </section>
    </div>
    </>
  );
};

export default OpenPublishingCoursePage;